import React from 'react';

import Footnotes from './Footnotes';
import Links from './Links';
import Privacy from './Privacy';
import Social from './Social';

const Footer = () => {
  return (
    <footer id="footer" className="med-hi">
      <div className="container">
        <Footnotes />
        <Social />
        <Links />
        <div className="clearfix" />
        <Privacy />
      </div>
    </footer>
  );
};

export default Footer;
